import type { ReactNode } from 'react';
import { Loading } from 'aha-components';
import { useTranslation } from 'react-i18next';

/** Keep the price area's dimensions while hiding temporary amounts. */
export default function CreatorPriceLoadingRegion({
  loading = false,
  disabled = loading,
  showText = true,
  children,
  className = ''
}: {
  loading?: boolean;
  disabled?: boolean;
  showText?: boolean;
  children: ReactNode;
  className?: string;
}) {
  const { t } = useTranslation();
  return (
    <div className={`relative min-w-0 ${className}`} aria-busy={loading}>
      <fieldset
        disabled={disabled}
        aria-hidden={loading || undefined}
        className={`m-0 min-w-0 border-0 p-0 ${loading ? 'invisible' : ''} ${disabled ? 'pointer-events-none' : ''}`}
      >
        {children}
      </fieldset>
      {loading ? (
        <div
          role="status"
          className="absolute inset-0 flex items-center justify-center gap-2 text-sm text-[#737373]"
        >
          <span aria-hidden="true" className="flex shrink-0">
            <Loading width={20} height={20} color="#EC470A" />
          </span>
          <span className={showText ? undefined : 'sr-only'}>
            {t('price.fields.loading', { defaultValue: 'loading price...' })}
          </span>
        </div>
      ) : null}
    </div>
  );
}
